export default __webpack_public_path__ + "static/media/upload-img.62e39aad.svg";